var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNotification2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(207,208,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.677 68.442 c 0 3.73 -3.051 6.781 -6.781 6.781 h 0 c -3.73 0 -6.781 -3.051 -6.781 -6.781",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(152,152,152)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.856 63.283 c -0.521 -0.345 -1.171 -0.693 -1.985 -1.045 c -5.164 -2.352 -4.87 -15.543 -5.681 -23.584 c -1.239 -8.201 -5.178 -13.348 -11.816 -15.442 c -0.859 -2.761 -3.443 -4.781 -6.478 -4.781 s -5.619 2.02 -6.478 4.781 c -6.638 2.094 -10.577 7.241 -11.816 15.442 c -0.81 8.041 -0.517 21.232 -5.681 23.584 c -0.814 0.353 -1.464 0.701 -1.985 1.045 c -1.082 0.716 -0.574 2.398 0.723 2.398 h 25.212 h 0.049 h 25.212 C 68.43 65.68 68.938 63.999 67.856 63.283 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(152,152,152)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.885 65.234 c 0 3.73 -3.051 6.781 -6.781 6.781 h 0 c -3.73 0 -6.781 -3.051 -6.781 -6.781",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.064 60.075 c -0.521 -0.345 -1.171 -0.693 -1.985 -1.045 c -5.164 -2.352 -4.87 -15.543 -5.681 -23.584 c -1.239 -8.201 -5.178 -13.348 -11.816 -15.442 c -0.859 -2.761 -3.443 -4.781 -6.478 -4.781 s -5.619 2.02 -6.478 4.781 c -6.638 2.094 -10.577 7.241 -11.816 15.442 c -0.81 8.041 -0.517 21.232 -5.681 23.584 c -0.814 0.353 -1.464 0.701 -1.985 1.045 c -1.082 0.716 -0.574 2.398 0.723 2.398 h 25.212 h 0.049 h 25.212 C 71.638 62.473 72.146 60.791 71.064 60.075 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNotification2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-notification2.1353358baa70d2d29d534ad3623713c4.svg";